export default "__VITE_ASSET__BRRUC$cY__"